import { Injectable } from '@angular/core';

export type ToastType = 'success' | 'success-light' | 'error' | 'warning';

interface ToastConfig {
  message: string;
  type: ToastType;
  duration?: number; // Duration in milliseconds, 0 for persistent toast
}

@Injectable({
  providedIn: 'root',
})
export class Toaster {
  show({ message, type, duration = 3000 }: ToastConfig): void {
    const toast = document.createElement('div');

    toast.classList.add('toast', type);
    toast.textContent = message;
    document.body.appendChild(toast);

    if (duration === 0) return;
    setTimeout(() => {
      toast.remove();
    }, duration);
  }
}
